module.exports = __webpack_public_path__ + "static/media/POSITIF.71979015.svg";